// @core/api/endpoints/project/get_board.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BoardResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Get board
 * Retrieves board configuration including columns, swimlanes, WIP limits, and display settings.
 */
export async function GetBoard(
  project_id: string,
  board_id: string,
  options?: RequestOptions
): Promise<BoardResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/boards/:board_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':board_id', encodeURIComponent(board_id));
  const requestOptions = options;
  return client.get<BoardResponse>(requestPath, { ...requestOptions });
}
